import React from 'react';
import { LOGO, NON_FIELD_ERRORS, UNKNOWN_ERROR_OCCURED } from './const';

export function validateForm(formRef, fieldsRefs, error, checkLogo, errorMessageDiv) {
    let errorMessage;

    try {
        const errorDetail = error.data.meta.detail;
        const errorTypes = Object.keys(errorDetail);

        errorTypes.forEach(errorType => {
            if (errorType === NON_FIELD_ERRORS) return;

            if (checkLogo && errorType === LOGO) {
                // eslint-disable-next-line prefer-destructuring
                errorMessage = errorDetail[errorType][0];
                errorMessageDiv.scrollIntoView({ behavior: 'smooth' });
                return;
            }

            const fieldReference = fieldsRefs[errorType];
            const feedbackErrorMessage = <>{errorDetail[errorType][0]}</>;

            formRef.showError(fieldReference, feedbackErrorMessage);
        });

        const nonFieldErrors = errorDetail[NON_FIELD_ERRORS];

        if (nonFieldErrors) {
            // eslint-disable-next-line prefer-destructuring
            errorMessage = nonFieldErrors[0];
        } else if (errorTypes.length === 0) {
            errorMessage = UNKNOWN_ERROR_OCCURED;
        }
    } catch (e) {
        //
    }

    return errorMessage;
}
